














































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import { Script } from "../interfaces/script";
import { User } from "../interfaces/user";
import { AuthService } from "../services/authService";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";

@Component({ components: { ConfirmDeleteDialog } })
export default class ModifyScriptCard extends Vue {
    @Prop() loading?: boolean;
    @Prop() type!: string;
    public deleteDialogActive: boolean = false;

    public get selectedIndex(): number {
        return this.scripts.map(s => s.name).indexOf(this.name.trim());
    }

    public set selectedIndex(v: number) {
        this.name = this.scripts[v].name;
    }
    public scripts: Script[] = [];

    public get user(): User | null {
        return this.$store.state.user;
    }
    public name: string = "";
    public loadScripts() {
        this.loadUserToStore().then(
            () => (this.scripts = this.user?.scripts ?? [])
        );
    }
    public async loadUserToStore() {
        // refreshes the script infos
        if (this.$auth.isAuthenticated) {
            const token = await this.$auth.getTokenSilently();
            const user: User | null = await AuthService.getUser(token);
            this.$store.commit("setUser", { user });
        }
    }
    public mounted() {
        this.loadScripts();
    }

    @Emit() load() {
        if (this.selectedIndex == null) {
            return;
        }
        return this.scripts[this.selectedIndex];
    }
    @Emit() deleteScript(confirmation: boolean) {
        this.deleteDialogActive = false;
        if (confirmation) {
            return this.scripts[this.selectedIndex].id;
        }
    }
    @Emit() save() {
        return this.name;
    }
    @Emit() cancel() {
        return;
    }
}
